var _defs, _line, _ellipse, _path, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#1a242d;stroke-miterlimit:10;stroke-width:0.9px;}.cls-1{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bruno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.41,
    y1: 5.28,
    x2: 21.41,
    y2: 10.59
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16.97,
    cy: 16.47,
    rx: 5.63,
    ry: 5.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.42,5.25,6.26,7.32l5.08,2.17a.93.93,0,0,0,.73,0l9.34-4.21a.12.12,0,0,0,0-.21l-5.3-2.38L11.82.77a1.28,1.28,0,0,0-1.08,0L1.81,4.91a1,1,0,0,0-.58.89L1.2,17a.85.85,0,0,0,.49.77L11.42,22a1.07,1.07,0,0,0,.94-.05h0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.17,
    y1: 7.28,
    x2: 16.11,
    y2: 2.69
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.971,
    y1: 18.831,
    x2: 19.838,
    y2: 14.858,
    style: {}
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.057,
    y1: 17.355,
    x2: 15.903,
    y2: 18.854,
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.254ada2be9c27872b7348a60b2833bfe.svg";
export { ForwardRef as ReactComponent };